import Ad from "../components/Ad";
import React from "react";
import styles from "../styles/Right.module.scss";
import { useSelector } from "react-redux";

const Right = () => {
  const { isInitializing, isLoading } = useSelector((state) => state.pagedata);
  return (
    <div className={styles.container}>
      <div className={styles.ad}>
        {!isLoading && !isInitializing && (
          <>
            <Ad id="right" />
            <Ad id="right_a" />
          </>
        )}
      </div>
    </div>
  );
};

export default Right;
